import { useState, useEffect } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { API, resolveMediaUrl } from "@/lib/ddfApi";
import { trackEvent } from "@/lib/analytics";

// Stores only the dismissal timestamp (non-PII).
const STORAGE_KEY = "ddf_subscribe_dismissed";
const DDF_LOGO =
  "https://customer-assets.emergentagent.com/job_ddf-landing/artifacts/kw281ner_DDF%20logo.png";

export default function SubscribeModal({ config }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setOpen(true);
  }, []);

  // Lets CSS hide the PWA install banner while the popup is open.
  useEffect(() => {
    document.body.classList.toggle("ddf-subscribe-open", open);
    return () => document.body.classList.remove("ddf-subscribe-open");
  }, [open]);

  const dismissForever = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setOpen(false);
  };

  const link = config?.subscribeLink || config?.registerLink || "";
  const bgUrl = resolveMediaUrl(config?.subscribeBgImage?.url);

  const handleSubscribe = () => {
    trackEvent("subscribe_click", { source: "subscribe_popup" });
    axios.post(`${API}/subscribe`, { source: "subscribe_popup" }).catch(() => {});
    localStorage.setItem("ddf_subscribed", "1");
    if (link) window.open(link, "_blank", "noopener,noreferrer");
    dismissForever();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && dismissForever()}>
      <DialogContent
        className={`ddf-subscribe-dialog max-w-md ${bgUrl ? "ddf-subscribe-dialog--bg" : ""}`}
        style={bgUrl ? { backgroundImage: `url("${bgUrl}")` } : undefined}
        data-testid="subscribe-modal"
      >
        <div className="ddf-subscribe-logo-wrap">
          <img src={DDF_LOGO} alt="Dubai Duty Free" className="ddf-subscribe-logo" />
        </div>
        <div className={bgUrl ? "sr-only" : "ddf-subscribe-body"}>
          <DialogTitle className="ddf-subscribe-title">
            Make every trip a little more rewarding.
          </DialogTitle>
          <DialogDescription className="ddf-subscribe-desc">
            Sign up now to unlock exclusive deals from <strong>Dubai Duty Free</strong> and
            get the best offers sent straight to your inbox.
          </DialogDescription>
        </div>
        <div className="ddf-subscribe-actions" data-testid="subscribe-actions">
          <div className="ddf-subscribe-form">
            <Button
              type="button"
              onClick={handleSubscribe}
              className="ddf-subscribe-btn"
              data-testid="subscribe-submit-btn"
            >
              Subscribe
            </Button>
          </div>
          <button
            type="button"
            onClick={dismissForever}
            className="ddf-subscribe-skip"
            data-testid="subscribe-skip-link"
          >
            No thanks, continue as guest
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
